import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { IbanXSBanksCountriesPivot as IbanXSBanksCountriesPivotComponent } from "ui/organizms/OpenBanking";

const IbanXSBanksCountriesPivot = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Open Banking | Iban XS Banks Countries Pivot'
    >
        <IbanXSBanksCountriesPivotComponent />
    </Screen>

);

export default memo(IbanXSBanksCountriesPivot);
